import { createSelector } from 'reselect';
import { getOrders } from '../orders'

export function getOrderList(state) {
  return state.orderlists;
}

export function getOrderListById(state, searchId) {
  return getOrderList(state).get(searchId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentOrderList = createSelector(
  getOrderList,
  orderlists => orderlists.get(orderlists.get('currentOrderListId'))
);

export const getOrdersForCurrentOrderList = createSelector(
  getCurrentOrderList,
  getOrders,
  ( orderlists, orders) => {
    return orderlists.orderIds.map( id => orders.get(id) );
  }
);
